import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {locations} from "../../../../Utilities/Location";
import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {
    loanLibraryCatalogItemModel,
    emptyLoanLibraryCatalogItemModel,
} from "./loanLibraryCatalogItemFactory";
import {LoanLibraryCatalogItemView} from "./LoanLibraryCatalogItemView";
import {loanLibraryCatalogItemApi} from "./loanLibraryCatalogItemApi";
import {libraryCatalogApi} from "../../libraryCatalogApi";
import {loanLibraryCatalogApi} from "../LoanLibraryCatalog/loanLibraryCatalogApi";
import {createListFromArrayOfObjects} from "../../../../Utilities/Types/listUtilities";

export const LoanLibraryCatalogItemContainer = ({
                                                    catalogItemId,
                                                    handleApiCall,
                                                    redirect,
                                                    systemType,
                                                }: ContextProps) => {

    const [catalogItem, setCatalogItem] = useState<Record<string, unknown> | null>(null);
    const [inventoryItems, setInventoryItems] = useState<Record<string, unknown>[]>([]);
    const isEdit = catalogItemId && catalogItemId !== emptyGuid;

    const [vendors, setVendors] = useState<Record<string, unknown>[]>();
    const [manufacturers, setManufacturers] = useState<Record<string, unknown>[]>();
    const vendorList = createListFromArrayOfObjects(vendors, "vendorId", "name");
    const manufacturerList = createListFromArrayOfObjects(manufacturers, "manufacturerId", "name");

    const loadLoanLibraryCatalogItemResult = (result: Record<string, unknown>) => {
        const loanLibraryCatalogItem = loanLibraryCatalogItemModel(result);
        setCatalogItem(loanLibraryCatalogItem);
        setInventoryItems(loanLibraryCatalogItem.inventoryItems as Record<string, unknown>[]);
    };


    useEffect(() => {
        const newLoanLibraryCatalogItem = emptyLoanLibraryCatalogItemModel;

        const getLoanLibraryCatalogItem = () => {
            handleApiCall(() => loanLibraryCatalogItemApi.getLoanLibraryCatalogItem(catalogItemId), (results = newLoanLibraryCatalogItem) => loadLoanLibraryCatalogItemResult(results));
        }

        const getVendors = () => {
            handleApiCall(() => libraryCatalogApi.getVendorsAll(), (results: Record<string, unknown>[]) => setVendors(results));

        };

        const getManufacturers = () => {
            handleApiCall(() => loanLibraryCatalogApi.getManufacturers(), (results: Record<string, unknown>[]) => setManufacturers(results));
        }

        if (isEdit && !catalogItem)
            getLoanLibraryCatalogItem();
        else
            setCatalogItem(newLoanLibraryCatalogItem);

        if (!vendors)
            getVendors();
        if (!manufacturers)
            getManufacturers();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catalogItemId]);

    const handleSave = (catalogItemToSave: Record<string, unknown>) => {
        if(isEdit)
            handleApiCall(
                () => loanLibraryCatalogItemApi.updateLoanLibraryCatalogItemWithInventory(catalogItemId, catalogItemToSave),
                () => redirect(locations.LOAN_LIBRARY_CATALOG.path)
            );
        else
            handleApiCall(
                () => loanLibraryCatalogItemApi.addLoanLibraryCatalogItemWithInventory(catalogItemToSave),
                () => redirect(locations.LOAN_LIBRARY_CATALOG.path)
            );
    }

    const handleCancel = () => {
        redirect(locations.LOAN_LIBRARY_CATALOG.path);
    };

    if (!catalogItem) return <></>;

    return (
        <>
            <LoanLibraryCatalogItemView
                handleReturn={handleCancel}
                handleSaveLoanLibraryCatalogItem={handleSave}
                inventoryItems={inventoryItems}
                isEdit={isEdit}
                loanLibraryCatalogItem={catalogItem}
                manufacturerList={manufacturerList}
                onInventoryChange={setInventoryItems}
                vendorList={vendorList}
            />
        </>
    );
};

